module.exports = __webpack_public_path__ + "guiding-principles-3.svg?4c03b00894dcd2a820bbd8f0cabc1b6a";


//////////////////
// WEBPACK FOOTER
// ./index_files/images/guiding-principles-3.svg
// module id = 47
// module chunks = 0